import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { REVIEWS } from "../../data/adminData";
import { PageTitle, Table, Badge, Btn, dt } from "./ui";

export default function Reviews() {
  const [list, setList] = useState(REVIEWS);
  const act = (id, status) => {
    if (status === "Dzēsta") setList((p) => p.filter((r) => r.id !== id));
    else setList((p) => p.map((r) => (r.id === id ? { ...r, status } : r)));
    toast.success(`Atsauksme ${status.toLowerCase()} (DEMO)`);
  };
  return (
    <div data-testid="admin-reviews">
      <PageTitle>Atsauksmes ({list.length}) <span className="text-sm font-semibold text-[#6B6B6B] normal-case">· {list.filter((r) => r.status === "Gaida").length} gaida moderāciju</span></PageTitle>
      <Table head={["Prece", "Autors", "Vērtējums", "Teksts", "Datums", "Statuss", "Darbības"]} minWidth="900px">
        {list.map((r) => (
          <tr key={r.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`review-row-${r.id}`}>
            <td className="p-3 font-semibold max-w-[180px] truncate">{r.product}</td>
            <td>{r.author}</td>
            <td><span className="flex items-center gap-0.5">{Array.from({ length: r.rating }).map((_, i) => <Star key={i} size={11} className="fill-[#E5A000] text-[#E5A000]" />)}</span></td>
            <td className="text-[#6B6B6B] max-w-[240px] truncate">{r.text}</td>
            <td className="text-[#6B6B6B]">{dt(r.date)}</td>
            <td><Badge color={r.status === "Apstiprināta" ? "green" : "amber"}>{r.status}</Badge></td>
            <td className="p-3">
              <div className="flex gap-1.5">
                {r.status === "Gaida" && <Btn onClick={() => act(r.id, "Apstiprināta")} data-testid={`review-approve-${r.id}`}>Apstiprināt</Btn>}
                <Btn variant="outline" onClick={() => act(r.id, "Dzēsta")} data-testid={`review-delete-${r.id}`}>Dzēst</Btn>
              </div>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
